// Cart Upsell Form - Custom element for adding upsell products to cart drawer
if (!customElements.get("cart-upsell-form")) {
  customElements.define(
    "cart-upsell-form",
    class CartUpsellForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        // Always find the cart drawer
        this.cartDrawer = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        try {
          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          const formData = new FormData(this.form);

          // Add sections for cart drawer update
          if (this.cartDrawer) {
            formData.append(
              "sections",
              this.cartDrawer.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
            this.cartDrawer.setActiveElement(document.activeElement);
          }

          config.body = formData;

          const response = await fetch(`${routes.cart_add_url}`, config);
          const result = await response.json();

          if (result.status) {
            // Handle error
            publish(PUB_SUB_EVENTS.cartError, {
              source: "cart-upsell-form",
              productVariantId: formData.get("id"),
              errors: result.description,
              message: result.message,
            });
            this.handleErrorMessage(result.description);

            const soldOutMessage =
              this.submitButton.querySelector(".sold-out-message");
            if (soldOutMessage) {
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
            }
            this.error = true;
            return;
          }

          // Success - update cart drawer
          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "cart-upsell-form",
              productVariantId: formData.get("id"),
            });
          }

          this.error = false;

          // Update cart drawer contents
          if (this.cartDrawer) {
            this.cartDrawer.renderContents(result);
          }
        } catch (error) {
          console.error("Error adding upsell product:", error);
          this.handleErrorMessage(
            "An error occurred while adding the product."
          );
        } finally {
          this.submitButton.classList.remove("loading");
          if (
            this.cartDrawer &&
            this.cartDrawer.classList.contains("is-empty")
          ) {
            this.cartDrawer.classList.remove("is-empty");
          }
          if (!this.error) {
            this.submitButton.removeAttribute("aria-disabled");
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
